import { graphql } from "@opensea/graphql"

export const AcceptOffersSummaryFragment = graphql(`
  fragment AcceptOffersSummary on Quote {
    totalPrice {
      pricePerToken {
        token {
          unit
          symbol
        }
        usd
      }
    }
    feeSummary {
      marketplaceFeeBasisPoints
      creatorFeeBasisPoints
    }
    itemQuotes {
      ... on ItemQuote {
        quantity
        item {
          collection {
            id
            name
            flags {
              isCreatorFeesEnforced
            }
            floorPrice {
              pricePerItem {
                usd
              }
            }
            fees {
              totalCreatorFee {
                isRequired
                feeBasisPoints
              }
            }
          }
        }
      }
    }
  }
`)
